const TableLoader = ({colspan}) => {
    return (
        <tr style={{background: "#494646ff"}}>
            <td style={{padding: "10px 0"}} colSpan={colspan}><div className="loading-container"><div className="dt-loader"></div></div></td>
        </tr>
    )
}

export default TableLoader